<template>
  <router-link
    :to="{ name: 'home', hash: '#join' }"
    class="free-trial title-font"
    :class="{ visible: isVisible }"
  >
    <span class="text">
      <span class="text-mobile">Free<br />Trial</span>
      <span class="text-desktop">Free Trial</span>
    </span>
  </router-link>
</template>

<script>
export default {
  name: "FloatingTrialButton",
  data() {
    return {
      isVisible: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isVisible = window.scrollY > 300;
    },
  },
};
</script>

<style scoped lang="scss">
@use "../../sass/utils/variables" as *;

.free-trial {
  position: fixed;
  top: 50%;
  right: 0;
  transform: translateY(-50%) translateX(100%);
  background-color: var(--button);
  color: var(--background);
  padding: 0.4em 0.6em;
  border-radius: 5px 0 0 5px;
  text-align: center;
  text-decoration: none;
  font-size: clamp(0.9rem, 1.2vw, 1.4rem);
  font-weight: bold;
  z-index: 1000;
  opacity: 0;
  transition: transform 0.6s ease, opacity 0.6s ease;

  &:hover {
    background-color: var(--hover-button);
  }

  &.visible {
    transform: translateY(-50%) translateX(0);
    opacity: 1;
  }

  .text-mobile {
    display: none;

    @media (max-width: 768px) {
      display: inline;
    }
  }

  .text-desktop {
    display: inline;

    @media (max-width: 768px) {
      display: none;
    }
  }
}
</style>
